"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAnswerableQuestion = void 0;
const FormQuestionType_1 = __importDefault(require("../FormQuestionType"));
const isAnswerableQuestion = (q) => q &&
    !!q.title &&
    q.type !== FormQuestionType_1.default.INFO &&
    q.type !== FormQuestionType_1.default.REPETITION &&
    q.type !== FormQuestionType_1.default.QUESTIONSET &&
    q.type !== FormQuestionType_1.default.SECTION;
exports.isAnswerableQuestion = isAnswerableQuestion;
exports.default = exports.isAnswerableQuestion;
